import React from 'react'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { Grid } from '@material-ui/core'

import ResearchDetail from '../../../shareUI/ResearchDetail/researchDetail'
import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'
import Dialog from '../../../../../control/dialog/dialog'
import { CloseProjectFormViewPropsType, CloseProjectFormType } from './closeProjectResearcherType'
import useCloseProjectResearcher from './useCloseProjectResearcher'
import constSubmittedStatus from '../../../../../constants/submittedStatus'
import RemarkFromAdmin from '../../../shareUI/remarkFromAdmin/remarkFromAdmin'
import PageAction from '../pageAction'
import DocumentTopics from '../../../shareUI/documentTopics/documentTopics'
import constSubmittedType from '../../../../../constants/submittedType'
import ResearcherDetail from '../../../shareUI/researcherDetail/researcherDetail'
import useCheckPermission from '../../../../../utilities/checkPermission'
import UploadAdditionalDoc from '../../../shareUI/uploadAdditionalDoc/UploadAdditionalDoc'
import useTranslate from '../../../../../i18n/useTranslate'

const CloseProjectResearcherView = (props: CloseProjectFormViewPropsType) => {
    const {
        documentTopicList,
        initialValues,
        projectData,
        initialUploadFile,
        isViewMode,
        onClickSubmit,
        configDialog,
        onRefDialogTwo,
        onClickCancel,
        handleDirtyChange,
        checkUseUploadEdit,
        isDraftData,
        onClickDeleteProject,
    } = props

    const translate = useTranslate()
    const isNotCompleteDocument = projectData?.submittedStatusInfo?.value === constSubmittedStatus.incorrectDocument
    const checkPermission = useCheckPermission()
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData)
    return (
        <Form
            onSubmit={onClickSubmit}
            initialValues={{ ...initialValues, form: [], uploadFile: initialUploadFile }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {({ handleSubmit, form, dirty }) => {
                return (
                    <React.Fragment>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <RemarkFromAdmin
                                    isShow={projectData?.verifyDocument === false}
                                    projectData={projectData ?? undefined}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ResearchDetail dataSource={projectData ?? undefined} />
                            </Grid>

                            <Grid item xs={12}>
                                <ResearcherDetail dataSource={projectData ?? undefined} />
                            </Grid>

                            <Grid item xs={12}>
                                <DocumentTopics
                                    title={translate.get('LABEL.PROJECT_COMPLETION_FORM')}
                                    irb={projectData?.irb}
                                    submittedTypeId={constSubmittedType.closeProject}
                                    isReadOnly={isViewMode}
                                    projectDataForm={projectData?.form ?? []}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <UploadDoc
                                    initialData={initialUploadFile}
                                    documentTitleList={documentTopicList}
                                    isViewMode={isViewMode && !canUpdateDocument}
                                    latestDocument={projectData?.latestDocument}
                                    isUseUploadfileEdit={checkUseUploadEdit()}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <UploadAdditionalDoc isViewMode={isViewMode && !canUpdateDocument} />
                            </Grid>

                            <Grid item xs={12}>
                                {!isViewMode || canUpdateDocument ? (
                                    <PageAction
                                        onClickDeleteProject={
                                            isDraftData
                                                ? () => {
                                                      onClickDeleteProject()
                                                  }
                                                : undefined
                                        }
                                        onClickClose={() => {
                                            onClickCancel(dirty)
                                        }}
                                        onClickSave={() => {
                                            form.change('submitType', 'save')
                                            handleSubmit()
                                        }}
                                        onClickSaveDraft={() => {
                                            form.change('submitType', 'draft')
                                            handleSubmit()
                                        }}
                                    />
                                ) : null}
                            </Grid>
                        </Grid>
                        <Dialog onRef={onRefDialogTwo} {...configDialog} />
                        <FormSpy subscription={{ dirty: true }} onChange={handleDirtyChange} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}

//Controller
const CloseProjectResearcher = (props: CloseProjectFormType) => {
    const useCloseProjectFormModel = useCloseProjectResearcher(props)
    return <CloseProjectResearcherView {...useCloseProjectFormModel} {...props} />
}
export default CloseProjectResearcher
